<template>
  <div class="elective">
    <div class="title" v-if="hasCourse">
      <p>请选择要学习的内容</p>
      <el-input class="book-filter" v-model="keywords" placeholder="输入关键字快速找到想要的书" />
    </div>
    <el-row v-if="hasCourse" class="course-content">
      <el-col :span="5" class="wrap">
        <el-radio-group v-model="filterType">
          <el-radio-button label="all">选课中心</el-radio-button>
          <el-radio-button label="my">我的课程</el-radio-button>
        </el-radio-group>
        <div class="course-type">
          <div
            class="course-item"
            v-for="(course, index) in courseList"
            :class="{'active': isCurrentCourse(course) }"
            :key="course.courseName"
            @click="changeCourse(index)"
          >
            <i class="iconfont" :class="course.icon" ></i>
            <span class="course-name">{{course.courseName}}</span>
            <div class="tooltips" v-if="course.courseName.length > 9">
              {{course.courseName}}
            </div>
            <span class="tr" v-if="course.courseName.length > 8"></span>
          </div>
        </div>
      </el-col>
      <el-col :span="1" class="space-wrap">
        <span class="space"></span>
      </el-col>
      <el-col :span="18" class="content">
        <div class="course" v-if="hasSubject">
          <div class="card"
            v-for="subject in currentCourseInfo.subject"
            :key="subject.name"
          >
            <div class="card-title">
              <span>{{subject.name}}</span>
            </div>
            <van-book-list
              :list="filteredBookList(subject.bookList)"
              :selected="isSelected"
              :learning="(book) => endLearnBookId === book.id"
              @click="selectBook"
              @dbclick="shortcutSelectBook"
            />
          </div>
        </div>
        <div class="course nope" v-else>
          <p class="no-course" v-if="isExpireCourse">暂无已过期课程</p>
          <p class="no-course" v-else>
            {{filterType === 'all' ? '暂无可体验课程，请联系老师为您开通' : '您的本科目暂无可学内容，请联系您的老师开通！'}}
          </p>
        </div>
      </el-col>
    </el-row>
    <div class="bottom" v-if="hasCourse">
      <div class="tip">鼠标左键点击两次课程名称即可进入学习哦!</div>
      <span :class="{'disable': !selectedBookInfo.id}" class="btn" @click="goUnit()">开始学习</span>
    </div>
    <div v-else class="nope">
      <span>暂无课程</span>
      <p class="tips">别人都在学，咱可不能落后呀！快联系你的老师买卡/订阅学习内容吧！</p>
    </div>
  </div>
</template>
<script>
import {
  Row,
  Col,
  RadioGroup,
  RadioButton,
  Input,
} from 'element-ui';
import api from '@/api/graphql/learning';
import services from '@/api/course';
import utils from '@/services/utils';
import VanBookList from './BookList.vue';

export default {
  components: {
    ElRow: Row,
    ElCol: Col,
    ElRadioGroup: RadioGroup,
    ElRadioButton: RadioButton,
    ElInput: Input,
    VanBookList,
  },
  data() {
    return {
      selectCourseId: 0,
      account: null,
      keywords: '',
      courseList: [],
      currentCourseInfo: {},
      filterType: '',
      endLearnBookId: null, // 最后一次学习的书id
      selectedBookInfo: {
        code: '',
        id: 0,
        name: '',
        describe: '',
        type: '',
        isExpire: 0,
      },
    };
  },
  computed: {
    hasSubject() {
      if (this.currentCourseInfo.courseName) {
        return this.currentCourseInfo.subject.length > 0;
      }
      return false;
    },
    hasCourse() {
      return this.courseList.length > 0;
    },
    isExpireCourse() {
      return this.currentCourseInfo.courseName === '已过期课程';
    },
  },
  watch: {
    filterType() {
      this.fetchCourseList();
    },
  },
  methods: {
    fetchCourseList() {
      api
        .getCourseList({
          type: this.filterType,
        })
        .then(({ courses }) => {
          const { courseInfo, lastTimeLearnedBook, endLearnBookId } = courses;
          this.courseList = courseInfo;
          const { isExpire, id } = lastTimeLearnedBook;
          this.endLearnBookId = endLearnBookId;
          this.selectedBookInfo = {
            ...lastTimeLearnedBook,
          };
          if (this.filterType === 'my' && id && !isExpire) {
            this.currentCourseInfo = this.getCurrentCourse(id) || {};
          } else {
            const [defaultCourseInfo] = courseInfo;
            if (defaultCourseInfo) {
              this.currentCourseInfo = defaultCourseInfo;
            }
          }
        });
    },
    markReadBook(bookId) {
      services
        .readBook({ book_id: bookId });
    },
    setLocalBookInfo() {
      utils.storage('bookInfo', {
        ...this.selectedBookInfo,
      });
    },
    // 通过书id查整个树
    getCurrentCourse(bookId) {
      for (let i = 0; i < this.courseList.length; i += 1) {
        for (let j = 0; j < this.courseList[i].subject.length; j += 1) {
          for (let k = 0; k < this.courseList[i].subject[j].bookList.length; k += 1) {
            if (this.courseList[i].subject[j].bookList.some(book => book.id === bookId)) {
              return this.courseList[i];
            }
          }
        }
      }
      return null;
    },
    isCurrentCourse(course) {
      return this.currentCourseInfo.courseName === course.courseName;
    },
    changeCourse(index) {
      this.currentCourseInfo = this.courseList[index];
      this.selectedBookInfo = {
        code: '',
        id: 0,
        name: '',
        describe: '',
        type: '',
        isExpire: 0,
      };
    },
    selectBook(book) {
      if (book.isExpire) {
        utils.error('该教材已过期');
        return;
      }
      this.selectedBookInfo = book;
    },
    shortcutSelectBook(book) {
      if (book.isExpire) {
        utils.error('该教材已过期');
        return;
      }
      this.selectedBookInfo = book;
      this.goUnit();
    },
    isSelected(book) {
      return book.id === this.selectedBookInfo.id;
    },
    goUnit() {
      if (this.selectedBookInfo.id) {
        this.setLocalBookInfo();
        this.markReadBook(this.selectedBookInfo.id);
        const { code, id } = this.selectedBookInfo;
        this.$router.push(`/learning-center/${code}/course/${id}`);
      }
    },
    filteredBookList(bookList) {
      if (!this.keywords.trim()) return bookList;

      return bookList.filter(book => book.name.indexOf(this.keywords) !== -1);
    },
  },
  beforeRouteEnter(to, from, next) {
    services
      .getQuizData()
      .then((res) => {
        next((vm) => {
          vm.filterType = res.is_exist_validity_book ? 'my' : 'all';
        });
      });
  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';
.elective {
  position: relative;
  .wrap {
    height: 100%;
    padding: 0 0 20px;
    overflow-y: auto;
    &::-webkit-scrollbar{
      width:5px;
    }
    &::-webkit-scrollbar-thumb{
      height: 30px;
      background-color:#999;
      outline-offset: -2px;
      outline: 2px solid #fff;
      -webkit-border-radius: 4px;
    }
    &:-webkit-scrollbar-track-piece {
      background-color:#f3f7f9;
    }
  }
  .title {
    position: relative;
    text-align: center;
    font-size: 20px;
    border-bottom: 1px solid #f2f2f2;
    p {
      margin: 0;
      padding: 20px 0;
    }
    .tip {
      margin-bottom: 20px;
      font-size: 12px;
    }
    .book-filter {
      position: absolute;
      top: 12px;
      right: 0;
      width: 220px;
    }
  }
  .space-wrap {
    text-align: center;
    .space {
      display: inline-block;
      height: 420px;
      width: 0;
      margin-top: 20px;
    }
  }
  .course-type{
    // margin-top: 30px;
    border: 2px solid #f2f2f2;
    border-radius: 4px;
    cursor: pointer;
    .course-item {
      position: relative;
      padding: 18px 20px 18px 50px;
      font-size: 18px;
      border-bottom: 2px solid #f2f2f2;
      &:last-child{
        border-bottom: 0;
      }
      .tooltips {
        display: none;
        position: absolute;
        top: 50px;
        left: 0;
        padding: 10px;
        width: 200px;
        background: #fff;
        border: 1px solid #999;
        z-index: 500;
        border-radius: 4px;
      }
      .tr {
        display: none;
        &:before, &:after {
          content: '';
          width: 0;
          height: 0;
          position: absolute;
          top: 32px;
          left: 50px;
          border: 10px solid transparent;
          border-color: transparent transparent #fff transparent;
          z-index: 501;
        }
        &:after {
          top: 29px;
          left: 49px;
          border-color: transparent transparent #999 transparent;
          border-width: 11px;
          z-index: 499;
        }

      }
      &:hover {
        .tooltips{
          display: block;
        }
        .tr{
          display: block;
        }
      }
      .iconfont {
        position: absolute;
        top: 18px;
        left: 15px;
        font-size: 20px;
        margin-right: 20px;
      }
      .icon-class{
        font-size: 16px;
        top: 20px;
      }
      .course-name {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        word-wrap: break-word;
        height: 21px;
      }
    }
    .active {
      &:before {
        content: '';
        position: absolute;
        top: -2px;
        left: -2px;
        width: 100%;
        height: 100%;
        border: 2px solid $primary;
        border-radius: 4px;
      }
    }
  }
  .course-content {
    height: calc(100% - 64px - 54px);
    .el-radio-group {
      width: 100%;
      margin: 10px 0;
      .el-radio-button {
        width: 50%;
        .el-radio-button__inner {
          width: 100%;
        }
      }
    }
  }
  .content{
    height: 100%;
    overflow-y: auto;
    &::-webkit-scrollbar{
      width:5px;
    }
    &::-webkit-scrollbar-thumb{
      height: 30px;
      background-color:#999;
      outline-offset: -2px;
      outline: 2px solid #fff;
      -webkit-border-radius: 4px;
    }
    &:-webkit-scrollbar-track-piece {
      background-color:#f3f7f9;
    }
    .course {
      // height: 420px;
      overflow-y: auto;
      padding: 0 10px 0 10px;
      .card {
        .card-title {
          line-height: 62px;
          font-size: 18px;
          color: $primary;
        }
      }
    }
    .nope {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .no-course {
        font-size: 20px;
        text-align: center;
        color: $grey-color;
      }
    }
  }
  .bottom {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 85%;
    padding: 10px 0 0;
    border-top: 2px solid #f2f2f2;
    text-align: right;
    background: #fff;
    .tip {
      position: absolute;
      left: 15px;
      bottom: 10px;
      font-size: 14px;
      color: #999;
    }
    .btn {
      display: inline-block;
      padding: 13px 30px;
      margin-right: 20px;
      margin-bottom: 10px;
      background: $primary;
      color: #fff;
      text-align: center;
      border-radius: 4px;
      cursor: pointer;
    }
    .disable {
      background: #999;
      cursor:not-allowed;
    }
  }
  .nope {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    text-align: center;
    font-size: 20px;
    color: $grey;
  }
}
</style>
